export const name = "TIME_SUB";
export const summary = `Subtracts a specified time interval from a \`TIME\` value.`;
export const reference = `
## TIME_SUB

Subtracts a specified time interval from a \`TIME\` value.

\`\`\`
TIME_SUB(time_expression, INTERVAL int64_expression part)
\`\`\`

### Description

Subtracts \`int64_expression\` units of \`part\` from the \`TIME\` object.

\`TIME_SUB\` supports the following values for \`part\`:

- \`MICROSECOND\`
- \`MILLISECOND\`
- \`SECOND\`
- \`MINUTE\`
- \`HOUR\`

This function automatically adjusts when values fall outside of the 00:00:00 to 24:00:00 boundary. For example, if you subtract an hour from \`00:30:00\`, the returned value is \`23:30:00\`.


### Return Data Type

\`TIME\`


### Example



\`\`\`
SELECT
  TIME "15:30:00" as original_date,
  TIME_SUB(TIME "15:30:00", INTERVAL 10 MINUTE) as earlier;

/*-----------------------------+------------------------*
 | original_date | earlier |
 +-----------------------------+------------------------+
 | 15:30:00 | 15:20:00 |
 *-----------------------------+------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/time_functions
`;
